export enum NumberingKinds {
  Monolithic = 1,
  Format = 2,
  ReportType = 3,
  Keyword = 4,
}
